// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"a388d69d","628":"ed1f4fee"}[chunkId] + ".chunk.js";
};